import { render, staticRenderFns } from "./ConfirmHeader.vue?vue&type=template&id=6851dfa6&scoped=true&"
import script from "./ConfirmHeader.vue?vue&type=script&lang=js&"
export * from "./ConfirmHeader.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmHeader.vue?vue&type=style&index=0&id=6851dfa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6851dfa6",
  null
  
)

export default component.exports